import { Configuration, RedirectRequest } from "@azure/msal-browser";

export const msalConfig: Configuration = {
	auth: {
		clientId: process.env.NEXT_PUBLIC_MICROSOFT_CLIENT_ID || "",
		authority: "https://login.microsoftonline.com/organizations",
		redirectUri: "/",
	},
	cache: {
		cacheLocation: "sessionStorage",
	},
};

export const loginRequest: RedirectRequest = {
	scopes: ["User.Read", "Openid", "Profile", "Email"],
};

export const MSAL_REDIRECT_RESULT_KEY = "msal-redirect-result";
export const MSAL_REDIRECT_ORIGIN_KEY = "msal-redirect-origin";
